import React from 'react';

import { RaisedButton } from 'material-ui';
import { useDispatch, useSelector } from 'react-redux';
import { WHITE } from '../../config/colors';
import { rootPageUri } from '../../config/uri';
import {
  getDispensaryName,
  getLogoUrlLink,
} from '../../selectors/configSelectors';
import './style.css';
import { pushWithQueryParams } from '../../services/uri';

function ThankYou() {
  const secondaryColor = useSelector(state => state.config.secondaryColor);
  const dispensaryLogo = useSelector(state => getLogoUrlLink(state));
  const dispensaryName = useSelector(state => getDispensaryName(state));
  const thankYouMessage = useSelector(state => state.config.ECOMMERCE_THANK_YOU_PAGE_MESSAGE);

  const dispatch = useDispatch();

  const returnToMenu = () => dispatch(pushWithQueryParams(rootPageUri));

  return (
    <div className="thank-you-page">
      {dispensaryLogo && <img src={dispensaryLogo}/>}
      {!dispensaryLogo &&  <h1 className="dispensary-name-title">{dispensaryName}</h1>}
      <p className="thank-you-message">{thankYouMessage}</p>
      
      <br/><br/>
      <RaisedButton
        backgroundColor={`#${secondaryColor}`}
        labelColor={WHITE}
        label="Return to Menu"
        labelStyle={{ fontWeight: 700 }}
        style={{ minWidth: '335px', margin: '0 auto'}}
        onClick={() => returnToMenu()}
      />
    </div>
  );
}

export default ThankYou;


// WEBPACK FOOTER //
// ./src/components/ThankYou/ThankYou.jsx